import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import Funil from "./pages/Funil";
import Privacy from "./pages/Privacy";
import MetodoPage from "./pages/MetodoPage";
import TrilhasPage from "./pages/TrilhasPage";
import Palestra from "./pages/Palestra";
import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./pages/admin/Layout";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminLeads from "./pages/admin/Leads";
import AdminLeadDetail from "./pages/admin/LeadDetail";
import AdminAgenda from "./pages/admin/Agenda";
import AdminFormulario from "./pages/admin/Formulario";
import AdminSettings from "./pages/admin/Settings";
import AdminPalestras from "./pages/admin/Palestras";
import RequireAdmin from "./components/admin/RequireAdmin";
import { SEO } from "./components/seo/SEO";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <SEO />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/metodo" element={<MetodoPage />} />
        <Route path="/trilhas" element={<TrilhasPage />} />
        <Route path="/privacidade" element={<Privacy />} />
        <Route path="/palestra" element={<Palestra />} />
        <Route path="/agendar/*" element={<Funil />} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminLayout />
            </RequireAdmin>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="leads" element={<AdminLeads />} />
          <Route path="leads/:id" element={<AdminLeadDetail />} />
          <Route path="agenda" element={<AdminAgenda />} />
          <Route path="formulario" element={<AdminFormulario />} />
          <Route path="palestras" element={<AdminPalestras />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
